// extracted by mini-css-extract-plugin
module.exports = {"orderSelect":"OrderStatusSelectField_orderSelect__oTxbi"};